<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <validation-observer ref="createObserver" slim>
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.categories.categoryImage') + ' EN'">
                <b-form-file v-model="createForm.image_en" accept="image/*"></b-form-file>
              </b-form-group>
              <b-form-group :label="$t('pages.categories.categoryImage') + ' RU'">
                <b-form-file v-model="createForm.image_ru" accept="image/*"></b-form-file>
              </b-form-group>
              <b-form-group :label="$t('pages.categories.categoryImage')">
                <b-form-file v-model="createForm.categoryImage" accept="image/*"></b-form-file>
              </b-form-group>

              <b-form-group :label="$t('pages.categories.categoryIcon')">
                <b-form-file v-model="createForm.categoryIcon" accept="image/*"></b-form-file>
              </b-form-group>

              <b-text-input-with-validation
                v-model="createForm.name_en"
                name="nameEn"
                :label="$t('pages.categories.categoryNameEn')"
                :disabled="isLoading"
                rules="required"
              ></b-text-input-with-validation>

              <b-text-input-with-validation
                v-model="createForm.name_ru"
                name="nameRu"
                :label="$t('pages.categories.categoryNameRu')"
                :disabled="isLoading"
                rules="required"
              ></b-text-input-with-validation>

              <b-form-group :label="$t('pages.categories.chooseParent')">
                <v-select
                  v-model="createForm.parent_id"
                  :options="parents"
                  :reduce="(parent) => parent.id"
                  label="name"
                />
              </b-form-group>

              <b-form-group :label="$t('anyform.chooseSection')">
                <v-select
                  v-model="createForm.section_id"
                  :options="sections"
                  :reduce="(section) => section.id"
                  label="name"
                />
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
                :class="{
                  'btn-multiple-state mt-2': true,
                  'show-spinner': isLoading
                }"
              >
                <span class="spinner d-inline-block">
                  <span class="bounce1"></span>
                  <span class="bounce2"></span>
                  <span class="bounce3"></span>
                </span>
                <span class="label">
                  {{ $t('buttons.save') }}
                </span>
              </b-button>
            </b-form>
          </validation-observer>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import BTextInputWithValidation from '@/components/Form/BTextInputWithValidation.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: { BTextInputWithValidation },
  data: () => ({
    isLoading: false,
    createForm: {
      categoryImage: null,
      categoryIcon: null,
      name_en: '',
      name_ru: '',
      parent_id: '',
      section_id: '',
      image_en: null,
      image_ru: null
    }
  }),
  computed: {
    parents() {
      const requirements = this.$store.getters['categories/requirements']
      return handleArrayDataInternalization(requirements.parents, ['name'], this.$i18n.locale)
    },
    sections() {
      const requirements = this.$store.getters['categories/requirements']
      return handleArrayDataInternalization(requirements.sections, ['name'], this.$i18n.locale)
    }
  },
  mounted() {
    this.fetchRequirements()
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    fetchRequirements() {
      this.$store.dispatch('categories/fetchRequirements')
    },
    async onSubmit() {
      const success = await this.$refs.createObserver.validate()
      if (success) {
        const payload = {
          name_en: this.createForm.name_en,
          name_ru: this.createForm.name_ru,
          image: this.createForm.categoryImage || '',
          icon: this.createForm.categoryIcon || '',
          parent_id: this.createForm.parent_id || '',
          section_id: this.createForm.section_id || '',
          image_en: this.createForm.image_en || '',
          image_ru: this.createForm.image_ru || ''
        }
        this.$store.dispatch('categories/createCategory', { payload, vm: this })
      }
    }
  }
}
</script>
